import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  OnInit,
} from "@angular/core";
import { PopoverService } from "../popover/popover.service";
import { ToolbarUserDropdownComponent } from "./toolbar-user-dropdown/toolbar-user-dropdown.component";
import icPerson from "@iconify/icons-ic/twotone-person";
import { GlobalCurrentUserService } from 'src/app/pages/Services/global-current-user.service';
import { SharedService } from 'src/app/pages/Services/shared.service';
import { TranslateService } from '@ngx-translate/core';
import { LanguageService } from 'src/app/pages/Services/language.service';
import { Observable } from 'rxjs';

@Component({
  selector: "nc-toolbar-user",
  templateUrl: "./toolbar-user.component.html",
  styleUrls: ["./toolbar-user.component.scss"],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ToolbarUserComponent implements OnInit {
  dropdownOpen: boolean;
  icPerson = icPerson;
  currentUser: any;
  lang$: Observable<string>;
  todayDate = new Date();

  constructor(private popover: PopoverService, private cd: ChangeDetectorRef, 
    private globalCurrentUserService: GlobalCurrentUserService,
    private sharedService:SharedService,
    public translate: TranslateService,
    private languageService: LanguageService
    ) {
      this.lang$ = this.languageService.getLanguage();
    }

  ngOnInit() {
    this.lang$.subscribe(lang => {
      this.translate.use(lang['fileName'])
    });
    this.sharedService.getCurrentActiveUser().subscribe(result=>{
      if(result){
        this.currentUser = result;
      }else{
        this.currentUser = JSON.parse( this.globalCurrentUserService.getCurrentUser());
        this.sharedService.updateCurrentActiveUser(this.currentUser);
      }
    })
  }

  showPopover(originRef: HTMLElement) {
    this.dropdownOpen = true;
    this.cd.markForCheck();

    const popoverRef = this.popover.open({
      content: ToolbarUserDropdownComponent,
      origin: originRef,
      offsetY: 12,
      position: [
        {
          originX: "center",
          originY: "top",
          overlayX: "center",
          overlayY: "bottom",
        },
        {
          originX: "end",
          originY: "bottom",
          overlayX: "end",
          overlayY: "top",
        },
      ],
    });

    popoverRef.afterClosed$.subscribe(() => {
      this.dropdownOpen = false;
      this.cd.markForCheck();
    });
  }
}
